import { combineLatest, firstValueFrom } from 'rxjs';
import { Component, inject, Input, OnInit } from '@angular/core';
import { Permissions_CDMS, Permissions } from 'src/app/Constants/Admin/Permissions';
import { Data_User_CDMS } from 'src/app/Interfaces/Admin/Data_User_CDMS.interface';
import { Response_Admin } from 'src/app/Interfaces/Admin/Response_Admin.interface';
import { Headers_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Headers-CCP.interface';
import { FilterGroupPipe } from 'src/app/Pipes/Admin/filter-group.pipe';
import { AdminService } from 'src/app/Services/Global/Admin/admin.service';
import Swal from 'sweetalert2';
import moment from 'moment';
import { RolesGeneral } from 'src/app/Interfaces/Admin/Roles.interface';
import { FilterRolePipe } from 'src/app/Pipes/Admin/filter-role.pipe';
import { Router } from '@angular/router';
import { TreeNode } from 'primeng/api';
import { GeneralCDMSService } from 'src/app/Services/Global/GeneralCDMS/general-cdms.service';
import { CategoryRole } from 'src/app/Interfaces/GeneralCDMS/Roles/CategoryRole.interface';
import { RoleCategoryCDMS, RoleTreeCDMS } from 'src/app/Interfaces/GeneralCDMS/Roles/RoleCDMS.interface';
import { typeCategoryRole } from 'src/app/types/General/Category.type';
import { RolesTranslate, RoleTranslateI, typeRoleCDMS } from 'src/app/types/General/RoleCDMS.type';
import { Response_GeneralCDMS } from 'src/app/Interfaces/GeneralCDMS/Response_GeneralCDMS.interface';
import { UserDataService } from 'src/app/Services/Authentication/User/user-data.service';
import { Group_New_Format, mapGroups } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Group.interface';

@Component({
    selector: 'app-relation-user-cdms',
    templateUrl: './relation-user-cdms.component.html',
    styleUrls: ['./relation-user-cdms.component.scss', '../../../Styles/GlobalStyles.css'],
    standalone: false
})
export class RelationUserCdmsComponent implements OnInit {

  private readonly HiddenLegacyGeneralAdminRoles: string[] = ['AdministratorGeneral', 'Administrator'];

  //+================== VARIABLES FOR HEADERS TASK ==================+\\
  public Headers_Roles: Headers_CCP[] = [
    { ID: 1, Name: 'Nombre', Position: 1, Visible: true, Key_Header: 'NAME' },
    { ID: 1, Name: 'Descripción', Position: 1, Visible: true, Key_Header: 'DESC' },
    { ID: 1, Name: 'Libreria', Position: 1, Visible: true, Key_Header: 'LIBR' },
    { ID: 1, Name: 'Opciones', Position: 1, Visible: true, Key_Header: 'OPTI' },
  ];

  //+================== VARIABLES FOR HEADERS TASK ==================+\\
  public Headers_Group: Headers_CCP[] = [
    { ID: 1, Name: 'Nombre', Position: 1, Visible: true, Key_Header: 'NAME' },
    { ID: 1, Name: 'Descripción', Position: 1, Visible: true, Key_Header: 'DESC' },
    { ID: 1, Name: 'Opciones', Position: 1, Visible: true, Key_Header: 'OPTI' },
  ];


  //+================== VARIABLES FOR SEARCH ==================+\\
  public Input_Search: string = '';
  public Input_Search_Role: string = '';

  public Input_Search_G: string = '';
  public Input_Search_Group: string = '';

  //+================== VARIABLES FOR PAGINATION ==================+\\
  public first: number = 0;
  public rows: number = 6;

  public first_group: number = 0;
  public rows_group: number = 6;


  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  private ColorConfirm: string = '#20a8e1';
  private ColorsCancel: string = '#fc6161';


  //+================== VARIABLES FOR LOAD PAGE ==================+\\
  public LoadPage: boolean = false;


  //+================== VARIABLES FOR PERMISIONS ==================+\\
  public Permisions: Permissions[] = Permissions_CDMS;

  public RoleOptions: TreeNode[] = [
    {
      key: '1',
      label: 'Super Administrador',
      data: {
        ID: 0,
        Name: 'Super Administrador',
        ID_Category: 0,
        CategoryName: '',
        IsCategory: true,
      },
      icon: 'fas fa-shield-alt',
      expanded: true,
      children: []
    }
  ]

  selectedRoles: any = [];

  //+================== VARIABLES FOR ROLES GENERAL AND CATEGORIES ==================+\\
  private Category: CategoryRole[] = [];
  private RolesGeneral: RoleCategoryCDMS[] = [];
  private RolesGeneralUser: RoleCategoryCDMS[] = [];


  //+================== VARIABLES FOR ROLES ==================+\\
  public All_Roles_Of_User: RolesGeneral[] = [];
  public Selected_All_Roles_Of_User: RolesGeneral[] = [];

  public All_Roles_CDMS: RolesGeneral[] = [];
  public All_Roles_CDMS_Copy: RolesGeneral[] = [];
  public All_Roles_CDMS_Copy_Search: RolesGeneral[] = [];

  //+================== VARIABLES FOR GROUPS ==================+\\
  public All_Group_Of_User: Group_New_Format[] = [];
  public Selected_All_Group_Of_User: Group_New_Format[] = [];

  public All_Groups_CDMS: Group_New_Format[] = [];
  public All_Groups_CDMS_Copy: Group_New_Format[] = [];
  public All_Groups_CDMS_Copy_Search: Group_New_Format[] = [];

  public User: Data_User_CDMS = {
    ID: 0,
    Nombre: '',
    email: '',
    Fecha_Modificacion: new Date(),
    LoginName: '',
  }

  //+================== VARIABLES FOR SNAPSHOTS ==================+\\
  @Input('IDU') ID_User: number = 0;


  //-========================= SERVICES =========================-\\
  private UserService = inject(UserDataService);
  private Service_Admin = inject(AdminService);
  private Service_GeneralCDMS = inject(GeneralCDMSService);
  private router = inject(Router)

  constructor() { }


  async ngOnInit(): Promise<void> {
    await this.Load_Component();
  }


  //&===================== FUNCTIONS FOR LOAD COMPONENT =====================&\\


  //-================== FUNCTTION FOR LOAD COMPONENT ==================-\\
  private async Load_Component(): Promise<void> {
    try {
      const resUsr: Response_Admin = await firstValueFrom(this.Service_Admin.Get_User_By_ID(this.ID_User));

      if (resUsr.success) {
        this.User = resUsr.operation;
      }
    } catch (e) {

      Swal.fire({
        title: 'Ocurrió un error (Usuario)',
        text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });
      return;
    }

    const Loader = document.getElementById('Loader') as HTMLDivElement;
    Loader.classList.add('active');

    try {
      await this.Load_All_Groups()
      await this.Load_All_Roles();
      await this.Load_Roles_Category()
      this.Clean_Role_Relation();
      this.Generate_Tree_Role();
      this.CompareRoles();
      this.Clean_Group_Relation()

      Loader.classList.remove('active');
      this.LoadPage = true;
    } catch (e) {

      Swal.fire({
        title: 'Ocurrió un error (Roles)',
        text: 'No se han podido obtener los roles. ¡Recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });
      Loader.classList.remove('active');
      this.LoadPage = true;
    }
    this.LoadPage = true;
  }

  private async Load_All_Groups(): Promise<boolean> {

    try {

      const ResGroups: Response_Admin = await firstValueFrom(this.Service_Admin.Get_All_Groups_CDMS());

      if (ResGroups.success) {

        this.All_Groups_CDMS = ResGroups.operation;

        this.All_Groups_CDMS = ResGroups.operation.map(mapGroups);

      } else {
        throw ResGroups.message;
      }

      const ResUsrGroups: Response_Admin = await firstValueFrom(this.Service_Admin.Get_User_Groups(this.ID_User));

      if (ResUsrGroups.success) {

        this.All_Group_Of_User = [];

        ResUsrGroups.operation.forEach(({ id_grupo }: { id_grupo: number }) => {
          const groups = this.All_Groups_CDMS.filter(group => group.ID_G === id_grupo);
          if (groups.length > 0) {
            this.All_Group_Of_User = this.All_Group_Of_User.concat(groups);
            this.All_Groups_CDMS = this.All_Groups_CDMS.filter(group => group.ID_G !== id_grupo);
          }
        });

        return true;

      } else {
        throw ResGroups.message;
      }

    } catch (e) {

      Swal.fire({
        title: 'Ocurrió un error (Grupos)',
        text: 'No se han podido cargar los grupos del usuario. ¡Recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });
      return false;
    }
  }

  //-================== FUNCTTION FOR LOAD ALL ROLES ==================-\\
  private async Load_All_Roles(): Promise<boolean> {

    try {

      const ResRoles: Response_Admin = await firstValueFrom(this.Service_Admin.Get_All_Roles_System());

      if (ResRoles.success) {

        this.All_Roles_CDMS = ResRoles.operation;

      } else {
        throw ResRoles.message;
      }

      const ResUsrRole: Response_Admin = await firstValueFrom(this.Service_Admin.Get_All_Roles_User({ ID_U: this.ID_User }));

      if (ResUsrRole.success) {

        this.All_Roles_Of_User = ResUsrRole.operation;

        return true;

      } else {
        throw ResRoles.message;
      }

    } catch (e) {

      Swal.fire({
        title: 'Ocurrió un error (Roles)',
        text: 'No se han podido cargar los roles del usuario. ¡Recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });
      return false;
    }
  }

  private async Load_Roles_Category(): Promise<boolean> {
    try {

      const [ResCategory, ResRoles, ResRolesGeneralUser] = await firstValueFrom(combineLatest([this.Service_GeneralCDMS.Get_All_Category_Roles_CDMS(), this.Service_GeneralCDMS.Get_All_Roles_General_CDMS(), this.Service_GeneralCDMS.Get_Roles_General_User({ ID_User: this.ID_User })]));

      if (ResCategory.success) {
        this.Category = [];
        this.Category = ResCategory.operation;
      }

      this.RoleOptions[0].children = this.Category.map((item: CategoryRole) => this.mapCategory(item, 1));

      if (ResRoles.success) {
        this.RolesGeneral = [];
        this.RolesGeneral = (ResRoles.operation || []).filter((item: RoleCategoryCDMS) => !this.IsHiddenLegacyGeneralAdminRole(item.Name));
      }

      if (ResRolesGeneralUser.success) {
        this.RolesGeneralUser = (ResRolesGeneralUser.operation.Category || []).filter((item: RoleCategoryCDMS) => !this.IsHiddenLegacyGeneralAdminRole(item.Name));
      }


      return true;
    } catch (e) {

      Swal.fire({
        title: 'Ocurrió un error (Roles)',
        text: 'No se han podido cargar los roles del usuario. ¡Recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });
      return false;
    }

  }

  private IsHiddenLegacyGeneralAdminRole(roleName: string): boolean {
    const normalized = String(roleName || '').trim().toUpperCase();
    return this.HiddenLegacyGeneralAdminRoles.some((role) => role.toUpperCase() === normalized);
  }

  //&===================== END FUNCTIONS FOR LOAD COMPONENT =====================&\\




  //&===================== FUNCTIONS FOR GENERAL COMPONENT =====================&\\

  //-================== FUNCTTION FOR CLEAN GROUPS ==================-\\
  private Clean_Group_Relation(): boolean {

    const Clean_Group: Group_New_Format[] = [];

    this.All_Groups_CDMS.forEach((Item: Group_New_Format) => {
      this.All_Group_Of_User.some((Item_F: Group_New_Format) => Item_F.Nombre === Item.Nombre) ? 0 : Clean_Group.push(Item);
    })

    this.All_Groups_CDMS = Clean_Group;
    this.All_Groups_CDMS_Copy = this.All_Groups_CDMS.slice(this.first_group, this.first_group + this.rows_group)

    return true;
  }

  private CompareRoles(): void {

    this.selectedRoles = [];

    this.RolesGeneralUser.forEach(roleUser => {
      const category = this.RoleOptions[0].children?.find(item => item.data.Name === roleUser.CategoryName);
      const role = category?.children?.find(item => item.data.Name === roleUser.Name);

      if (role) {
        this.selectedRoles.push(role);
      }
    });

    this.RoleOptions[0].children?.forEach((category: TreeNode) => {
      const selectedRoles = this.selectedRoles.filter((item: TreeNode) => item.data.CategoryName === category.data.Name);
      const rolesMatch = selectedRoles.length === category.children?.length;

      category.partialSelected = selectedRoles.length > 0 ? !rolesMatch : false;

      if (rolesMatch) {
        this.selectedRoles.push(category);
      }
    });

    this.RoleOptions[0].partialSelected = this.selectedRoles.length > 0;
    this.selectedRoles.filter((item: TreeNode) => item.data.IsCategory === false).length === this.RolesGeneral.length ? this.selectedRoles.push(this.RoleOptions[0]) : 0
  }

  //-================== FUNCTTION FOR GENERATE TREE ROLE ==================-\\
  private Generate_Tree_Role(): boolean {

    if (this.RoleOptions[0].children) {
      for (const cat of this.RoleOptions[0].children) {
        cat.children = this.RolesGeneral.filter((item: RoleCategoryCDMS) => item.CategoryName === cat.data.CategoryName).map((item2: RoleCategoryCDMS) => this.mapRoles(item2, cat.key || ''))
      }
    }

    return true;
  }

  private mapCategory(item: CategoryRole, key: number): TreeNode {

    const data: RoleTreeCDMS = {
      ID: item.ID,
      Name: item.Name,
      ID_Category: item.ID,
      CategoryName: item.Name,
      IsCategory: true,
    };

    const mapDir: TreeNode = {
      key: `${key}-${item.ID}`,
      label: this.GetCategoryName(item.Name),
      data: data,
      icon: this.GetIconCategory(item.Name),
      expanded: false,
      children: []
    }
    return mapDir

  }

  private mapRoles(item: RoleCategoryCDMS, key: string): TreeNode {
    const data: RoleTreeCDMS = {
      ID: item.ID,
      Name: item.Name,
      ID_Category: item.ID_Category,
      CategoryName: item.CategoryName,
      IsCategory: false,
    };

    const mapDir: TreeNode = {
      key: `${key}-${item.ID}`,
      label: this.GetRoleName(item.Name as typeRoleCDMS),
      data: data,
      icon: '',
      expanded: false,
      children: []
    }
    return mapDir
  }

  //-================== FUNCTTION FOR CLEAN ROLES ==================-\\
  private Clean_Role_Relation(): boolean {

    const Clean_Role: RolesGeneral[] = [];

    this.All_Roles_CDMS.forEach((Item: RolesGeneral) => {
      this.All_Roles_Of_User.some((Item_F: RolesGeneral) => Item_F.ID === Item.ID && Item_F.Library === Item.Library) ? 0 : Clean_Role.push(Item);
    })

    this.All_Roles_CDMS = Clean_Role;
    this.All_Roles_CDMS_Copy = this.All_Roles_CDMS.slice(this.first, this.first + this.rows)

    return true;
  }

  //-================== FUNCTTION FOR FORMAT LOGIN NAME ==================-\\
  public Format_LoginName(LoginName: string): string {
    return LoginName.trim() === '' ? 'CDMS' : LoginName.trim();
  }

  //-================== FUNCTTION FOR INITIALS CARD ==================-\\
  public Format_Initials(Name: string): string {
    let Initials: string = '';
    let NameSplit: string[] = Name.split(' ');

    Initials += NameSplit[0][0] || '?';
    NameSplit.length > 1 ? Initials += NameSplit[1][0] || '' : Initials += NameSplit[0][1] || '';

    return Initials;
  }

  //-================== FUNCTTION FOR RELOAD PAGE ==================-\\
  public Reload_Page(fullReload: boolean = false): void {

    const currentUserID = Number(localStorage.getItem('ID_U_DB')) || 0;
    if (currentUserID > 0 && currentUserID === this.ID_User) {
      this.UserService.RefrestDataUser();
    }

    if (fullReload) {
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } else {
      this.Load_Component();
    }
  }

  //-================== FUNCTTION FOR PAGINATION ==================-\\
  public onPageChange(event: any): void {

    this.first = event.first;
    this.rows = event.rows;

    this.All_Roles_CDMS_Copy = this.Input_Search_Role.length < 2 ? this.All_Roles_CDMS.slice(event.first, event.first + event.rows) : this.All_Roles_CDMS_Copy_Search.slice(event.first, event.first + event.rows);

  }

  //-================== FUNCTTION FOR PAGINATION ==================-\\
  public onPageChangeGroup(event: any): void {

    this.first_group = event.first;
    this.rows_group = event.rows;

    this.All_Groups_CDMS_Copy = this.Input_Search_Group.length < 2 ? this.All_Groups_CDMS.slice(event.first, event.first + event.rows) : this.All_Groups_CDMS_Copy_Search.slice(event.first, event.first + event.rows);

  }

  //-================ FUNCTION FOR VALIDATE SEARCH ================-\\
  public Search_Validate(): void {

    if (this.Input_Search.length < 2) {
      Swal.fire({
        title: 'Búsqueda no valida',
        text: '¡La búsqueda es muy corta, mínimo 2 caracteres!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });
    } else {
      this.Search_User();
    }

  }

  //-================ FUNCTION FOR SEARCH WHIT KEY ENTER ================-\\
  public Search_Enter($event: KeyboardEvent): void {
    $event.code === 'Enter' ? this.Search_Validate() : 0;
  }

  //-================== FUNCTTION FOR SEARCH USER ==================-\\
  public Search_User(): void {
    this.Input_Search_Role == '' || this.Input_Search_Role.length < 2 ?
      this.All_Roles_CDMS_Copy = this.All_Roles_CDMS.slice(this.first, this.first + this.rows) :
      (this.All_Roles_CDMS_Copy_Search = new FilterRolePipe().transform(this.All_Roles_CDMS, this.Input_Search_Role), this.All_Roles_CDMS_Copy = this.All_Roles_CDMS_Copy_Search.slice(this.first, this.first + this.rows));
  }

  //-================ FUNCTION FOR VALIDATE SEARCH ================-\\
  public Search_Validate_Group(): void {

    if (this.Input_Search_G.length < 2) {
      Swal.fire({
        title: 'Búsqueda no valida',
        text: '¡La búsqueda es muy corta, mínimo 2 caracteres!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });
    } else {
      this.Search_User_Group();
    }

  }

  //-================ FUNCTION FOR SEARCH WHIT KEY ENTER ================-\\
  public Search_Enter_Group($event: KeyboardEvent): void {
    $event.code === 'Enter' ? this.Search_Validate_Group() : 0;
  }

  //-================== FUNCTTION FOR SEARCH USER ==================-\\
  public Search_User_Group(): void {
    this.Input_Search_Group == '' || this.Input_Search_Group.length < 2 ?
      this.All_Groups_CDMS_Copy = this.All_Groups_CDMS.slice(this.first_group, this.first_group + this.rows_group) :
      (this.All_Groups_CDMS_Copy_Search = new FilterGroupPipe().transform(this.All_Groups_CDMS, this.Input_Search_Group), this.All_Groups_CDMS_Copy = this.All_Groups_CDMS_Copy_Search.slice(this.first_group, this.first_group + this.rows_group));
  }

  //-================ FUNCTION FOR FORMAT LIBRARY ================-\\
  public Library_String(Library: number): string {

    switch (Library) {
      case 2: return 'HOE';
      case 4: return 'ISO';
      case 5: return 'Processes';
      case 7: return 'Safety & Health Processes';
      case 8: return 'IT/IS Processes';
      default: return '';
    }
  }

  //-================ FUNCTION FOR SEE ROLE ================-\\
  public See_Role_Library(Role: RolesGeneral): void {

    switch (Role.Library) {
      case 2: this.router.navigate([`Dashboard/CCP/EditeRoleCCP/${Role.ID}`]); break;
      case 4: this.router.navigate([`Dashboard/ISO/EditeRoleISO/${Role.ID}`]); break;
      case 5: this.router.navigate([`Dashboard/FIN/EditeRoleFIN/${Role.ID}`]); break;
      case 7: this.router.navigate([`Dashboard/IT/EditeRoleIT/${Role.ID}`]); break;
      case 8: this.router.navigate([`Dashboard/SEC/EditeRoleSEC/${Role.ID}`]); break;
      default: this.router.navigate([`Dashboard/Admin/MenuGeneralRol`]);
    }

  }

  //-================ FUNCTION FOR RETURN CATEGORY NAME ================-\\
  public GetCategoryName(name: typeCategoryRole): string {
    switch (name) {
      case 'Administrator': return 'Administrador';
      case 'Manuals': return 'Manuales';
      case 'Templates': return 'Formularios';
      case 'Reports': return 'Reportes';
      case 'RecycleBin': return 'Papelera de reciclaje'
      case 'Libraries': return 'Librerías'
      case 'QualityPolicies': return 'Política de Calidad'
      case 'RisksOpportunities': return 'Riesgos y oportunidades'
      default: return ''
    }

  }

  public GetIconCategory(name: typeCategoryRole): string {
    switch (name) {
      case 'Administrator': return 'fas fa-user-shield';
      case 'Manuals': return 'fas fa-book-bookmark';
      case 'Templates': return 'fas fa-book-bookmark';
      case 'Reports': return 'fas fa-clipboard';
      case 'RecycleBin': return 'fas fa-recycle';
      case 'Libraries': return 'fas fa-books';
      case 'QualityPolicies': return 'fas fa-file-signature'
      case 'RisksOpportunities': return 'far fa-clipboard'
      default: return ''
    }

  }

  public GetRoleName(name: typeRoleCDMS): string {
    const isFind = RolesTranslate.find((item: RoleTranslateI) => item.Key === name);
    if (isFind !== undefined) {
      return isFind.Spanish;
    }

    const roleName = String(name);
    if (roleName.startsWith('Administrator')) {
      return `Admin ${this.FormatDynamicRoleSuffix(roleName.slice('Administrator'.length))}`.trim();
    }

    if (roleName.startsWith('Reports')) {
      return `Reportes ${this.FormatDynamicRoleSuffix(roleName.slice('Reports'.length))}`.trim();
    }

    if (roleName.startsWith('RecycleBin')) {
      return `Papelera ${this.FormatDynamicRoleSuffix(roleName.slice('RecycleBin'.length))}`.trim();
    }

    return roleName;
  }

  private FormatDynamicRoleSuffix(rawSuffix: string): string {
    const cleaned = rawSuffix.replace(/_/g, ' ').trim();
    if (!cleaned) {
      return '';
    }

    return cleaned
      .toLowerCase()
      .replace(/\b\w/g, (letter: string) => letter.toUpperCase());
  }

  //&===================== END FUNCTIONS FOR GENERAL COMPONENT =====================&\\


  //&===================== FUNCTIONS FOR UPDATE USER GROUP =====================&\\

  //-================== FUNCTTION FOR OPEN MODAL TO RELATION USER ==================-\\
  public Toggle_Modal_Relation_User_Group(Close_Or_Open: boolean): void {
    const Modal_Relation_User_Group = document.getElementById('Modal_Relation_User_Group') as HTMLElement;
    Close_Or_Open ? Modal_Relation_User_Group.classList.add('active') : Modal_Relation_User_Group.classList.remove('active');
  }

  //-================== FUNCTTION FOR SAVE RELATION USER ==================-\\
  public Add_User_To_Group(Group: Group_New_Format): void {

    Swal.fire({
      title: '¿Desea relacionar el grupo al usuario?',
      text: `¡${this.User.Nombre} ahora será parte de ${Group.Nombre}!`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: '¡Sí, agregar!'
    }).then(async (result) => {

      if (result.isConfirmed) {

        try {

          const ResRelation: Response_Admin = await firstValueFrom(this.Service_Admin.Relation_User_CDMS({ ID_G: Group.ID_G, ID_U: this.User.ID }))

          if (ResRelation.success) {
            this.All_Group_Of_User = [...this.All_Group_Of_User, Group];
            this.Input_Search_Group = '';
            this.Clean_Group_Relation();

            const Toast = Swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 2000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
              }
            })

            Toast.fire({
              icon: 'success',
              title: 'Relación con grupo creada!'
            })

            this.Reload_Page(true);
          } else {
            throw ResRelation.message;
          }

        } catch (e) {
          Swal.fire({
            title: 'Ocurrió un error',
            text: '¡Intente nuevamente agregar el usuario al grupo, si el problema persiste notifique a supervisor!',
            icon: 'warning',
            confirmButtonColor: this.ColorConfirm
          });
        }


      }

    })
  }

  //&===================== END FUNCTIONS FOR UPDATE USER GROUP =====================&\\



  //&===================== FUNCTIONS FOR UPDATE USER =====================&\\

  //-================== FUNCTTION FOR OPEN MODAL TO RELATION USER ==================-\\
  public Toggle_Modal_Relation_User(Close_Or_Open: boolean): void {
    const Modal_Relation_User = document.getElementById('Modal_Relation_User') as HTMLElement;
    Close_Or_Open ? Modal_Relation_User.classList.add('active') : Modal_Relation_User.classList.remove('active');
  }

  //-================== FUNCTTION FOR SAVE RELATION USER ==================-\\
  public Add_User_To_Role(Role: RolesGeneral): void {

    Swal.fire({
      title: '¿Desea relacionar el rol al usuario?',
      text: `¡${this.User.Nombre} ahora será parte de ${Role.Name}!`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: '¡Sí, agregar!'
    }).then(async (result) => {

      if (result.isConfirmed) {

        try {

          const ResRelation: Response_Admin = await firstValueFrom(this.Service_Admin.Relate_User_Role({ ID_Role: Role.ID, ID_User: this.ID_User, ID_Library: Role.Library }))

          if (ResRelation.success) {
            this.All_Roles_Of_User = [...this.All_Roles_Of_User, Role];
            this.Input_Search_Role = '';
            this.Clean_Role_Relation();

            const Toast = Swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 2000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
              }
            })

            Toast.fire({
              icon: 'success',
              title: 'Relación con rol creada!'
            })

            this.Reload_Page(true);
          } else {
            throw ResRelation.message;
          }

        } catch (e) {
          Swal.fire({
            title: 'Ocurrió un error',
            text: '¡Intente nuevamente agregar el usuario al rol, si el problema persiste notifique a supervisor!',
            icon: 'warning',
            confirmButtonColor: this.ColorConfirm
          });
        }


      }

    })
  }

  //&===================== END FUNCTIONS FOR UPDATE USER =====================&\\

  //-================== FUNCTTION FORMAT DATE ==================-\\
  public Date_Format(Date_Modification: Date): string {
    return moment(Date_Modification).utc().format('DD/MM/YYYY')
  }

  //-================== FUNCTTION FOR ADD CLASS IF EXIST MAIL ==================-\\
  public ContainMail(Mail: string): string {
    return Mail.trim() === '' ? 'Not-Mail' : 'Mail';
  }

  //-================== FUNCTTION FOR FORMAT MAIL ==================-\\
  public Format_Mail(Mail: string): string {
    return Mail.trim() === '' ? 'Sin Correo' : Mail.trim();
  }

  //&===================== FUNCTIONS FOR DELETE USER =====================&\\

  //-================== FUNCTTION FOR DELETE RELATION USER ==================-\\
  public Delete_User_To_Role(Role: RolesGeneral): void {

    Swal.fire({
      title: '¿Desea eliminar el usuario del rol?',
      text: `¡${this.User.Nombre} se eliminará de ${Role.Name}!`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: '¡Sí, eliminar!'
    }).then(async (result) => {

      if (result.isConfirmed) {

        try {

          const ResRelation: Response_Admin = await firstValueFrom(this.Service_Admin.Delete_User_Role({ ID_Role: Role.ID, ID_User: this.ID_User, ID_Library: Role.Library }))

          if (ResRelation.success) {

            this.All_Roles_Of_User = this.All_Roles_Of_User.filter(item => !(item.ID === Role.ID && item.Library === Role.Library));
            this.All_Roles_CDMS.push(Role);

            this.Clean_Role_Relation();

            const Toast = Swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 2000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
              }
            })

            Toast.fire({
              icon: 'success',
              title: '¡Relación a rol eliminado!'
            })

            this.Reload_Page(true);
          } else {
            throw ResRelation.message;
          }

        } catch (e) {
          Swal.fire({
            title: 'Ocurrió un error',
            text: '¡Intente eliminar nuevamente la relacion del rol, si el problema persiste notifique a supervisor!',
            icon: 'warning',
            confirmButtonColor: this.ColorConfirm
          });
        }


      }

    })
  }


  //&===================== END FUNCTIONS FOR DELETE USER =====================&\\


  //&===================== FUNCTIONS FOR ROLES GENERAL =====================&\\

  public SaveChanges() {

    const SelectRoles: TreeNode[] = this.selectedRoles.filter((item: TreeNode) => item.data.IsCategory === false);

    const IDsRole: number[] = SelectRoles.map((item: TreeNode) => item.data.ID).sort((a, b) => a - b);

    Swal.fire({
      title: '¿Desea guardar los cambios realizados al usuario?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: 'Sí, guardar'
    }).then(async (result) => {

      if (result.isConfirmed) {

        try {

          const ResUpdate: Response_GeneralCDMS = await firstValueFrom(this.Service_GeneralCDMS.Update_Roles_General_User({ ID_User: this.ID_User, IDs_Role: IDsRole }))

          if (ResUpdate.success) {

            const Toast = Swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 2000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
              }
            })

            Toast.fire({
              icon: 'success',
              title: 'Los cambios del usuario se han guardado correctamente.'
            })

            this.Reload_Page(true);

          } else {
            throw ResUpdate.message;
          }

        } catch (e) {
          Swal.fire({
            title: 'Se ha producido un error',
            text: 'Intente guardar nuevamente los cambios del usuario. Si el problema persiste, por favor notifique a su supervisor.',
            icon: 'warning',
            confirmButtonColor: this.ColorConfirm
          });
        }


      }

    })
  }

  //&===================== END FUNCTIONS FOR ROLES GENERAL =====================&\\

  //-================== FUNCTTION FOR DELETE RELATION USER ==================-\\
  public Delete_User_To_Group(Group: Group_New_Format): void {

    Swal.fire({
      title: '¿Desea eliminar el usuario al grupo?',
      text: `¡${this.User.Nombre} se eliminará de ${Group.Nombre}!`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: '¡Sí, eliminar!'
    }).then(async (result) => {

      if (result.isConfirmed) {

        try {

          const ResRelation: Response_Admin = await firstValueFrom(this.Service_Admin.Delete_Relation_User_CDMS({ ID_G: Group.ID_G, ID_U: this.User.ID }))

          if (ResRelation.success) {

            this.All_Group_Of_User = this.All_Group_Of_User.filter(item => item.ID_G !== Group.ID_G);
            this.All_Groups_CDMS.push(Group);

            this.Clean_Group_Relation();

            const Toast = Swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 2000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
              }
            })

            Toast.fire({
              icon: 'success',
              title: '¡Relación a grupo eliminado!'
            })

            this.Reload_Page(true);
          } else {
            throw ResRelation.message;
          }

        } catch (e) {
          Swal.fire({
            title: 'Ocurrió un error',
            text: '¡Intente eliminar nuevamente la relacion del grupo, si el problema persiste notifique a supervisor!',
            icon: 'warning',
            confirmButtonColor: this.ColorConfirm
          });
        }


      }

    })
  }


  //&===================== END FUNCTIONS FOR DELETE USER =====================&\\

}
